import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';

import { useShipFromContext } from '../../contexts/ship-from-context';

import { messages } from '../messages';

export const SaveButton = () => {
  const { loading, onSave } = useShipFromContext();

  return (
    <Button disabled={loading} onClick={onSave} theme='primary'>
      <FormattedMessage {...messages.saveChanges} />
    </Button>
  );
};
